import styled from 'styled-components';
import { GlobalColors, GlobalFonts } from '../../globals';

export const ContBtnLanguage = styled.div`
  margin-left: 10px;
  width: auto;
  display: flex !important;
  align-items: center !important;
  flex-direction: row !important;
`

export const ContLanguage = styled.div`
  font-family: ${GlobalFonts.fontGilroy};
  color: ${GlobalColors.colorTextDiscreet};
  display: flex !important;
  justify-content: center;
  align-content: center;
  align-items: center;
`
export const ContGLobe = styled.div`
  margin-right: 1px
`
export const ContArrowLenguage = styled.div`

`

export const ContPopover = styled.div`
  width: 200px,
  margin-top: 20px;
`